import { useMemo } from 'react'

import { T, VStack } from 'govwell-ui'

import { AcceptedAllFileTypes } from 'src/constants'
import { ListEnding, formatListSentence } from 'src/utils'

import { BreakpointComponents } from '../../../constants/breakpoints'
import { useCurrentBreakpoint } from '../../../hooks/use-current-breakpoint'

type Props = {
  accept?: string
}
export const Default = ({ accept }: Props) => {
  const supportedFileTypes = useMemo(() => {
    if (!accept || accept === AcceptedAllFileTypes) {
      return 'All file types accepted'
    }
    return formatListSentence({
      words: accept?.replaceAll('.', '')?.toUpperCase()?.split(',') || [],
      hideFinalPeriod: true,
      finalItemDelimiter: ListEnding.OR,
    })
  }, [accept])

  const { isSmall } = useCurrentBreakpoint()
  const small = isSmall(BreakpointComponents.FileUpload)

  return (
    <VStack gap={1} align="center" justify="center">
      <T.Body className="text-link hover:underline">
        Drag and drop files here or click to upload
      </T.Body>
      {!small && <T.BodySmall className="text-neutral-600">{supportedFileTypes}</T.BodySmall>}
    </VStack>
  )
}
